import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import { Collections } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import { COLLECTIONS_QUERY_KEY } from "./useCollections";
const getCollection = async ({ id }) => Collections.get(id);
const useCollection = (collectionId, { enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [COLLECTIONS_QUERY_KEY, collectionId],
    queryFn: () => defaultOnError(
      getCollection({ id: collectionId }),
      i18n.t("notifications.fetch_collection_failed", { ns: "enterprise_collections", collection_id: collectionId }),
      i18n.t("notifications.fetch_collection_failed_title", {
        ns: "enterprise_collections",
        collection_id: collectionId
      })
    ),
    enabled
  });
  return {
    data,
    isLoading,
    refetch
  };
};
export default useCollection;
